import React, { useEffect } from "react";
import { connect } from "react-redux";
import Card from "components/card";
import SummaryHeader from "components/header/SummaryHeader";
import { LucideCalendar, UserX, Users } from "lucide-react";
import SelectOption from "components/select/SelectOption";
import AbsenceSummaryCard from "./components/AbsenceSummaryCard";
import HeaderComponent from "components/card/HeaderComponent";
import AbsencesCard from "./components/AbsencesCard";
import { 
  getLeaveList, getLeaveStat
} from "../../../../redux/leave/leaveState";
import { 
  getCountryList, getDepartmentList, getLeaveStateList,
} from "../../../../redux/optionlist/optionlistState";
import { handleTableChange } from "utils";
import { Pagination } from "antd";


const TeamAbsences = ({
  pagination, 
  doSearch, 
  filters = {}, 
  countryList,
  departmentList,
  getDepartment,
  getCountry,
  recordList,
  getLeaveState,
  leaveStateList,
  getStats,
  recordStat,
}) => {

  useEffect(() => {
    getCountry();
    getDepartment();
    getLeaveState();
    getStats();
  }, [
      getDepartment, getCountry, 
      getLeaveState,  getStats
    ]
  );

  useEffect(() => {
    doSearch({paginate: pagination.per_page});
  }, [doSearch, pagination.per_page]);

  const onSelectFilter = (field, value) => {
    const data = {
      ...(filters || {}),
      page: 1,
      paginate: pagination?.per_page || 10,
    };

    if (value && value !== "all") {
      data[field] = value;
    } else {
      delete data[field];
    }
    
    doSearch(data);
  };



  return (
    <div className="flex flex-col gap-6">
      <SummaryHeader
        title="Team Absences Overview"
        icon={UserX}
        description="Monitor team member absences and leave schedules"
        color="violet"
      />
      <AbsenceSummaryCard
        currentlyOut={recordStat?.currently_out }
        upcomingThisWeek={recordStat?.upcoming_this_week }
        upcomingThisMonth={recordStat?.upcoming_this_month }
        totalDays={recordStat?.total_days }
      />
      <Card className="rounded-xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
          <SelectOption
            placeholder="All Departments"
            options={departmentList}
            value={filters?.department_id || "all"}
            onChange={(value) => onSelectFilter("department_id", value)}
          />

          <SelectOption
            placeholder="All Locations"
            options={countryList}
            value={filters?.country_id || "all"}
            onChange={(value) => onSelectFilter("country_id", value)}
          />

          <SelectOption
            placeholder="All Status"
            options={leaveStateList}
            value={filters?.lve_state || "all"}
            onChange={(value) => onSelectFilter("lve_state", value)}
          />
        </div>
      </Card>


      <HeaderComponent
        title="Team Member Absences"
        description={`Showing ${recordList?.length || 0} absences`}
      >
        <div className="max-h-[500px] overflow-y-auto pr-2">
          <div className="space-y-4">
            {recordList && recordList.length > 0 ? (
              recordList.map((leave) => 
                <AbsencesCard 
                  key={leave?.lve_id} 
                  {...leave}
                  onChange={handleTableChange(doSearch, filters)}
                />)
            ) : (
              <div className="text-center py-12">
                <Users className="w-12 h-12 text-slate-700 mx-auto mb-4 dark:text-slate-100"/>
                <p className="text-slate-700 dark:text-slate-100">No absences found matching the filters</p>
              </div>
            )}
          </div>
          <div className="flex justify-end py-4">
            <Pagination
              current={pagination.current_page}
              pageSize={pagination.per_page}
              total={pagination.total}
              showSizeChanger={false}
              onChange={(page) =>
                doSearch({
                  ...filters,
                  page,
                  paginate: pagination.per_page,
                })
              }
            />
          </div>
        </div>
      </HeaderComponent>
      <div className="flex items-center justify-between p-6 rounded-2xl border border-emerald-200 bg-gradient-to-br from-emerald-50 to-white dark:bg-gradient-to-r dark:from-emerald-900 dark:to-intsamis-800">
        <div>
          <h4 className="font-semibold mb-1 dark:text-white">Need to plan coverage?</h4>
          <p className="text-[13px] text-slate-700 dark:text-slate-100">
            Review upcoming leaves and coordinate team coverage
          </p>
        </div>
        <button
          className="gap-2 btn-gradient-emerald h-8 px-4 py-2 text-sm"
        >
          <LucideCalendar size={16}/>
          View Calendars
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.leave.leaveList?.items,
  recordStat: state.leave.leaveStat.data,
  pagination: state.leave.leaveList?.pagination,
  filters: state.leave.leaveList.filters,
	countryList: state.optionlist.countryList?.items,
  departmentList: state.optionlist.departmentList?.items,
  leaveStateList: state.optionlist.leaveStateList?.items,
});
const mapDispatchToProps = (dispatch) => ({
  getLeaveState: (data) => dispatch(getLeaveStateList(data)),
  getCountry: (data) => dispatch(getCountryList(data)),
  getStats: (data) => dispatch(getLeaveStat(data)),
  getDepartment: (data) => dispatch(getDepartmentList(data)),
  doSearch: (filters) => dispatch(getLeaveList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamAbsences);
